import { getHTML } from "../../../../utilities/getHTML";
import { parseInformer } from "./parseInformer";
import { slideEvents } from "./slideEvents";
import { slidePrayerList } from "./slidePrayerList";
import "./index.scss";
export function getInformer() {
    console.time("informer");
    getHTML("https://www.cedarparkchurchofchrist.org/members/member-news")
        .then((html) => {
        const parsedInformer = parseInformer(html.querySelector(".post"));
        if (parsedInformer.html) {
            slideEvents(parsedInformer.events);
            slidePrayerList(parsedInformer.group, "group");
            slidePrayerList(parsedInformer.expectant, "expectant");
            slidePrayerList(parsedInformer.prayerlist);
        }
        else {
            console.warn("Login required to display informer");
        }
        console.timeEnd("informer");
    })
        .catch((e) => console.error(e));
}
